import React from 'react';

const Card = ({ children, className }) => (
  <div className={`bg-white p-6 rounded-lg shadow-sm ${className}`}>
    {children}
  </div>
);

const PlanCard = ({ data }) => {
  return (
    <Card>
      <div className="mb-2">
        <h3 className="font-bold text-gray-800">{data.planName}</h3>
        <p className="text-sm text-gray-500">{data.periodStart} - {data.periodEnd}</p>
      </div>
      <div>
        <p className="text-sm text-gray-600">今月の発行件数</p>
        <p className="text-3xl font-bold text-gray-800">{data.invoiceCount} <span className="text-base font-normal">件</span></p>
      </div>
      <div className="mt-3">
        <p className="text-sm text-gray-600">超過従量</p>
        <p className="text-xl font-bold text-orange-500">{data.invoiceOverage} <span className="text-base font-normal">件</span></p>
      </div>
    </Card>
  );
};

export default PlanCard;
